import React from 'react';
export function SocialProofSection() {
  const testimonials = [{
    name: 'Sarah J.',
    quote: "Martha's after-meal trick alone made a huge difference for me. My readings are down an average of 25 points!",
    location: 'Denver, CO',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ocDG7BRN8evTHaxbRDdrAD/sarah.jpg'
  }, {
    name: 'Robert T.',
    quote: 'I was skeptical about the supplement, but after 3 months my A1C dropped from 7.8 to 6.5. My doctor was amazed.',
    location: 'Atlanta, GA',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/veSRAeALaeNo24P95tBJCT/robert.jpg'
  }, {
    name: 'Linda M.',
    quote: "The food diary revelation changed everything. Foods I thought were 'safe' were causing huge spikes. Thank you, Martha!",
    location: 'Portland, OR',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rzp3iV7m6LY4vbrqQuT333/linda.jpg'
  }];
  return <section className="mb-16" data-id="element-98">
      <h2 className="text-2xl md:text-3xl font-bold text-emerald-800 mb-8" data-id="element-99">
        What Others Are Saying
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-100">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg shadow-md p-6" data-id="element-101">
            <div className="flex items-center mb-4" data-id="element-102">
              <div className="h-12 w-12 rounded-full overflow-hidden" data-id="element-103">
                <img src={testimonial.image} alt={`Photo of ${testimonial.name}`} className="w-full h-full object-cover" data-id="element-104" />
              </div>
              <div className="ml-3" data-id="element-105">
                <p className="font-medium text-gray-800" data-id="element-106">{testimonial.name}</p>
                <p className="text-sm text-gray-500" data-id="element-107">{testimonial.location}</p>
              </div>
            </div>
            <p className="text-gray-700 italic" data-id="element-108">"{testimonial.quote}"</p>
          </div>)}
      </div>
      <div className="flex flex-wrap justify-center gap-6 mb-10" data-id="element-109">
        <div className="bg-white rounded-full py-2 px-6 shadow-md flex items-center" data-id="element-110">
          <span className="text-emerald-700 font-bold mr-2" data-id="element-111">✓</span>
          <span className="text-gray-700" data-id="element-112">Over 12,000 Readers</span>
        </div>
        <div className="bg-white rounded-full py-2 px-6 shadow-md flex items-center" data-id="element-113">
          <span className="text-emerald-700 font-bold mr-2" data-id="element-114">★</span>
          <span className="text-gray-700" data-id="element-115">4.9/5 Rating (3,421 Reviews)</span>
        </div>
        <div className="bg-white rounded-full py-2 px-6 shadow-md flex items-center" data-id="element-116">
          <span className="text-emerald-700 font-bold mr-2" data-id="element-117">✓</span>
          <span className="text-gray-700" data-id="element-118">Science-Backed Ingredients</span>
        </div>
      </div>
      <div className="mb-6" data-id="element-119">
        <a href="https://track.marthaslife.blog/click" target="_blank" rel="noopener noreferrer" className="block w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg transition duration-300 text-center text-lg cursor-pointer" onClick={() => {
        try {
          nbpix('event', 'lander_click');
        } catch (e) {
          console.warn('NB pixel not available', e);
        }
      }} data-id="element-120">
          Get The Formula That Changed My Life — While Supplies Last!
        </a>
        <p className="mt-3 text-sm text-amber-700 font-medium text-center" data-id="element-121">
          Limited Stock Available! Due to high demand, this formula sells out
          regularly.
        </p>
      </div>
      <div className="bg-white rounded-lg p-6" data-id="element-122">
        <h3 className="text-lg font-semibold text-emerald-700 mb-3" data-id="element-123">
          Scientific References:
        </h3>
        <ul className="text-sm text-gray-600 space-y-2" data-id="element-124">
          <li data-id="element-125">
            PubMed ID: 14633804 - Cinnamon improves glucose and lipids of people
            with type 2 diabetes
          </li>
          <li data-id="element-126">
            PubMed ID: 21105157 - Bitter melon (Momordica charantia) reduces
            elevated fasting plasma glucose levels
          </li>
          <li data-id="element-127">
            PubMed ID: 24716552 - Mulberry leaf extract improves glycemic
            control in patients with prediabetes
          </li>
          <li data-id="element-128">
            PubMed ID: 17072885 - Juniper berry intake and its effect on glucose
            levels in diabetic models
          </li>
        </ul>
      </div>
    </section>;
}